import { Component, OnInit, Output, EventEmitter, Input, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ComponentType } from 'src/app/models/component-type';
import { SolutionSpace } from 'src/app/models/solution';
import { ResponsiveService } from 'src/app/services/responsive.service';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { NgStyle } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
  selector: 'app-type-field',
  templateUrl: './type-field.component.html',
  styleUrls: ['./type-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatOptionModule,
    NgStyle,
    MatButtonModule,
  ],
})
export class TypeFieldComponent implements OnInit {
  @Output() selectionChange = new EventEmitter<ComponentType>();
  @Output() createNew = new EventEmitter();
  @Output() edit = new EventEmitter<string>();
  @Input() optionArray: ComponentType[];
  @Input() defaultChoice: string | undefined;
  @Input() solution: SolutionSpace;
  @Input() enableCreation = true;
  @Input() isEditable = true;

  formControl: UntypedFormControl;

  constructor() {}

  setValue(search: string): void {
    this.formControl.setValue(search);
  }

  identify(index: number, item: ComponentType): string {
    return item.id;
  }

  ngOnInit(): void {
    this.formControl = new UntypedFormControl(this.defaultChoice);
  }

  notify(): void {
    this.selectionChange.emit(this.optionArray.find((c) => c.id == this.formControl.value));
  }

  createNewClicked(): void {
    this.createNew.emit();
  }

  editClicked(event: MouseEvent, value: string): void {
    this.edit.emit(value);
  }

  isHumidity(): boolean {
    return this.solution === SolutionSpace.Humidity;
  }
}
